'use client';
import React from 'react';
import styles from '../styles/VideoItem.module.css';
import './VideoItem.css';
import { ImageSkeleton } from '@/app/_components/Skeleton/ImageSkeleton';
import ReactPlayer from 'react-player';
import { Modal, ModalContent, ModalBody, Button, useDisclosure } from '@nextui-org/react';
import Image from 'next/image';
import { HiPlayCircle } from 'react-icons/hi2';
import YouTubeVideo from './YouTube.client';

export interface Item {
    id: number;
    VideoTitle: string;
    VideoImgUrl: string;
    VideoImgAlt: string;
    VideoImgWidth: number;
    VideoImgHeight: number;
    VideoFileUrl: string;
}

interface VideoItemProps {
    item: Item;
}

function getFullUrl(relativeUrl: string) {
    const assetsBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL_INTERNAL;
    return `${assetsBaseUrl}${relativeUrl}`;
}

function getVideoUrl(relativeUrl: string) {
    const assetsBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL_EXTERNAL;
    return `${assetsBaseUrl}${relativeUrl}`;
}

const CustomPlayIcon = (props: any) => {
    return (
        <svg stroke="currentColor" viewBox="0 0 24 24" fill="currentColor" {...props}>
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z" clipRule="evenodd" />
        </svg>
    );
};

export const VideoItem = ({ item }: any) => {
    // console.dir(item);
    const { VideoIfYoutube, VideoYoutubeID } = item;
    const newVideoUrl = item.VideoFileUrl ? getVideoUrl(item.VideoFileUrl) : '';
    const { isOpen, onOpen, onOpenChange } = useDisclosure();

    return (
        <div className={styles.VideoItem}>
            {/*<HiPlayCircle className={`w-16 h-16 text-black opacity-80 hover:opacity-100`} />*/}
            <div className={`relative h-[250px] overflow-hidden`}>
                <Image
                    // prettier-ignore
                    className="absolute inset-0 object-cover w-full h-full"
                    src={getFullUrl(item.VideoImgUrl)}
                    alt={item.VideoImgAlt || 'Video'}
                    width={item.VideoImgWidth}
                    height={item.VideoImgHeight}
                    style={{
                        aspectRatio: `${item.VideoImgWidth}/${item.VideoImgHeight}`,
                        objectFit: 'cover',
                    }}
                />
                <div className={`absolute inset-0 bg-[#000000] bg-opacity-20 cursor-pointer hover:bg-opacity-50 transition-colors`} onClick={onOpen}>
                    <div className={`relative z-10 h-full flex flex-col justify-center items-center`}>
                        <CustomPlayIcon className={`w-16 h-16 text-black  hover:opacity-100 transition-colors`} />
                    </div>
                </div>
            </div>
            <div>
                <h2 className={`${styles.VideoTitle}`}>{item.VideoTitle}</h2>
            </div>
            <Modal
                // prettier-ignore
                size="4xl"
                backdrop="opaque"
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                classNames={{
                    body: 'p-4 rounded-none',
                    backdrop: 'bg-[#000000] bg-opacity-50',
                    // base: 'border-[#292f46] bg-[#19172c] dark:bg-[#19172c] text-[#a8b0d3]',
                    closeButton: 'bg-gray-800 hover:bg-black text-white transition-colors z-30',
                }}
            >
                <ModalContent>
                    <ModalBody>
                        <div className={styles.VideoWrapper}>
                            {(VideoIfYoutube && VideoYoutubeID) || newVideoUrl ? (
                                <>
                                    {VideoIfYoutube && VideoYoutubeID ? (
                                        <YouTubeVideo videoId={VideoYoutubeID} />
                                    ) : (
                                        <ReactPlayer
                                            // prettier-ignore
                                            controls={true}
                                            url={newVideoUrl}
                                            width="100%"
                                            height="100%"
                                        />
                                    )}
                                </>
                            ) : null}
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </div>
    );
};
